import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-details-backorder',
  templateUrl: './order-details-backorder.component.html',
  styleUrls: ['./order-details-backorder.component.scss'],
})
export class OrderDetailsBackorderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
